import BREAKPOINTS from '@lib/constants/breakpoints';
import COLORS from '@lib/constants/colors';
import styled from 'styled-components';

const RichTextWrapper = styled.div`
  p {
    margin: max(0.83vw, 26px) 0px;
    line-height: 2;

    font-weight: 100;
    font-size: 1rem;
  }

  button {
    margin: max(1.25vw, 18px) auto 2rem;

    @media screen and (max-width: ${BREAKPOINTS.medium}) {
      width: 100%;
    }
  }

  table {
    margin: max(0.83vw, 26px) 0px;
  }

  h2 {
    font-size: 30px;
    margin: max(1.25vw, 18px) 0px;
  }

  h2 a,
  h3 a {
    font-weight: bold;
  }

  h3 {
    font-size: 26px;
    margin: max(1.04vw, 16px) 0px;
  }

  h4 {
    font-size: 22px;
    margin: max(1.04vw, 16px) 0px;
  }

  ul,
  ol {
    margin: max(0.83vw, 26px) 0px;
    padding-left: 24px;
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }

  li {
    line-height: 2;

    font-weight: 100;

    font-size: 1rem;
    /* margin-bottom: 1rem; */

    padding-left: 10px;
    margin-left: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  a {
    color: ${COLORS.pink};
    font-weight: normal;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default RichTextWrapper;
